import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, of } from 'rxjs';

import { BaseMiscApiService } from '@common/api/base-misc-api.service';
import { AppConstants } from '@apps/app.constants';
import { Its2Constants } from '../its2.constants';
import { DepartmentApi } from './models/department-api';

@Injectable({
    providedIn: 'root'
})
export class DepartmentsMiscApiService extends BaseMiscApiService
{
    constructor (http: HttpClient)
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlIts2;
        this.segmentApi = `/${Its2Constants.BaseApi}/easyvista/departments`;
    }

    getDepartments (): Observable<DepartmentApi[]>
    {
        return this.get<DepartmentApi[]>();
    }

    getDepartment (departmentCode: string): Observable<DepartmentApi>
    {
        return this.get<DepartmentApi>(`/${departmentCode}`);
    }
}
